/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Space Invoices API
 * REST API for invoice management, customer management, and accounting operations. Features include cursor-based pagination for efficient data navigation, flexible JSON querying with MongoDB-style operators, full-text search across multiple fields, and comprehensive metadata support for custom tracking.
 * OpenAPI spec version: 1.0.0
 */
import type {
  AdvanceInvoice,
  AdvanceInvoiceList,
  CompleteAdvanceInvoicePreview,
  CreateAdvanceInvoice,
  CustomCreateAdvanceInvoice,
  DocumentVersion,
  DocumentVersionList,
  Error,
  GetAdvanceInvoiceByIdParams,
  GetAdvanceInvoicesParams,
  GetShareableAdvanceInvoiceHtmlParams,
  GetShareableAdvanceInvoicePdfParams,
  PartialAdvanceInvoicePreview,
  RenderAdvanceInvoicePreviewParams,
  UpdateAdvanceInvoice,
  ValidationError,
  VoidAdvanceInvoiceBody
} from '../model';

import { customFetch } from '../../mutator/custom-fetch';

/**
 * Retrieve advance invoice data using a shareable token. No authentication required. Returns full advance invoice data for rendering.
 * @summary View shareable advance invoice
 */
export type getShareableAdvanceInvoiceResponse200 = {
  data: AdvanceInvoice
  status: 200
}

export type getShareableAdvanceInvoiceResponse404 = {
  data: void
  status: 404
}

export type getShareableAdvanceInvoiceResponseSuccess = (getShareableAdvanceInvoiceResponse200) & {
  headers: Headers;
};
export type getShareableAdvanceInvoiceResponseError = (getShareableAdvanceInvoiceResponse404) & {
  headers: Headers;
};

export type getShareableAdvanceInvoiceResponse = (getShareableAdvanceInvoiceResponseSuccess | getShareableAdvanceInvoiceResponseError)

export const getGetShareableAdvanceInvoiceUrl = (shareableId: string,) => {


  

  return `/advance-invoices/shareable/${shareableId}`
}

export const getShareableAdvanceInvoice = async (shareableId: string, options?: RequestInit): Promise<getShareableAdvanceInvoiceResponse> => {
  
  return customFetch<getShareableAdvanceInvoiceResponse>(getGetShareableAdvanceInvoiceUrl(shareableId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Get advance invoice as HTML preview using a shareable token. No authentication required. Supports multiple languages via locale query parameter.
 * @summary Get shareable advance invoice as HTML
 */
export type getShareableAdvanceInvoiceHtmlResponse200 = {
  data: string
  status: 200
}

export type getShareableAdvanceInvoiceHtmlResponse404 = {
  data: void
  status: 404
}

export type getShareableAdvanceInvoiceHtmlResponseSuccess = (getShareableAdvanceInvoiceHtmlResponse200) & {
  headers: Headers;
};
export type getShareableAdvanceInvoiceHtmlResponseError = (getShareableAdvanceInvoiceHtmlResponse404) & {
  headers: Headers;
};

export type getShareableAdvanceInvoiceHtmlResponse = (getShareableAdvanceInvoiceHtmlResponseSuccess | getShareableAdvanceInvoiceHtmlResponseError)

export const getGetShareableAdvanceInvoiceHtmlUrl = (shareableId: string,
    params?: GetShareableAdvanceInvoiceHtmlParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/advance-invoices/shareable/${shareableId}/html?${stringifiedParams}` : `/advance-invoices/shareable/${shareableId}/html`
}

export const getShareableAdvanceInvoiceHtml = async (shareableId: string,
    params?: GetShareableAdvanceInvoiceHtmlParams, options?: RequestInit): Promise<getShareableAdvanceInvoiceHtmlResponse> => {
  
  return customFetch<getShareableAdvanceInvoiceHtmlResponse>(getGetShareableAdvanceInvoiceHtmlUrl(shareableId,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Download advance invoice as PDF using a shareable token. No authentication required. Supports multiple languages via locale query parameter.
 * @summary Download shareable advance invoice as PDF
 */
export type getShareableAdvanceInvoicePdfResponse200 = {
  data: Blob
  status: 200
}

export type getShareableAdvanceInvoicePdfResponse404 = {
  data: void
  status: 404
}

export type getShareableAdvanceInvoicePdfResponseSuccess = (getShareableAdvanceInvoicePdfResponse200) & {
  headers: Headers;
};
export type getShareableAdvanceInvoicePdfResponseError = (getShareableAdvanceInvoicePdfResponse404) & {
  headers: Headers;
};

export type getShareableAdvanceInvoicePdfResponse = (getShareableAdvanceInvoicePdfResponseSuccess | getShareableAdvanceInvoicePdfResponseError)

export const getGetShareableAdvanceInvoicePdfUrl = (shareableId: string,
    params?: GetShareableAdvanceInvoicePdfParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/advance-invoices/shareable/${shareableId}/pdf?${stringifiedParams}` : `/advance-invoices/shareable/${shareableId}/pdf`
}

export const getShareableAdvanceInvoicePdf = async (shareableId: string,
    params?: GetShareableAdvanceInvoicePdfParams, options?: RequestInit): Promise<getShareableAdvanceInvoicePdfResponse> => {
  
  return customFetch<getShareableAdvanceInvoicePdfResponse>(getGetShareableAdvanceInvoicePdfUrl(shareableId,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Create a new advance invoice with line items. Advance invoices are issued before goods/services are delivered to collect prepayment. When payment is received, the advance can be linked to a final invoice to apply the prepaid amount.
 * @summary Create a new advance invoice
 */
export type createAdvanceInvoiceResponse201 = {
  data: AdvanceInvoice
  status: 201
}

export type createAdvanceInvoiceResponse400 = {
  data: Error
  status: 400
}

export type createAdvanceInvoiceResponse401 = {
  data: Error
  status: 401
}

export type createAdvanceInvoiceResponse403 = {
  data: Error
  status: 403
}

export type createAdvanceInvoiceResponse404 = {
  data: Error
  status: 404
}

export type createAdvanceInvoiceResponse422 = {
  data: ValidationError
  status: 422
}

export type createAdvanceInvoiceResponse500 = {
  data: Error
  status: 500
}

export type createAdvanceInvoiceResponseSuccess = (createAdvanceInvoiceResponse201) & {
  headers: Headers;
};
export type createAdvanceInvoiceResponseError = (createAdvanceInvoiceResponse400 | createAdvanceInvoiceResponse401 | createAdvanceInvoiceResponse403 | createAdvanceInvoiceResponse404 | createAdvanceInvoiceResponse422 | createAdvanceInvoiceResponse500) & {
  headers: Headers;
};

export type createAdvanceInvoiceResponse = (createAdvanceInvoiceResponseSuccess | createAdvanceInvoiceResponseError)

export const getCreateAdvanceInvoiceUrl = () => {


  

  return `/advance-invoices`
}

export const createAdvanceInvoice = async (createAdvanceInvoice: CreateAdvanceInvoice, options?: RequestInit): Promise<createAdvanceInvoiceResponse> => {
  
  return customFetch<createAdvanceInvoiceResponse>(getCreateAdvanceInvoiceUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createAdvanceInvoice,)
  }
);}
  

/**
 * Retrieve a paginated list of advance invoices with optional filtering and sorting. Supports cursor-based pagination, JSON querying with MongoDB-style operators, full-text search, and sorting.
 * @summary List all advance invoices
 */
export type getAdvanceInvoicesResponse200 = {
  data: AdvanceInvoiceList
  status: 200
}

export type getAdvanceInvoicesResponse400 = {
  data: Error
  status: 400
}

export type getAdvanceInvoicesResponse401 = {
  data: Error
  status: 401
}

export type getAdvanceInvoicesResponse403 = {
  data: Error
  status: 403
}

export type getAdvanceInvoicesResponse404 = {
  data: Error
  status: 404
}

export type getAdvanceInvoicesResponse500 = {
  data: Error
  status: 500
}

export type getAdvanceInvoicesResponseSuccess = (getAdvanceInvoicesResponse200) & {
  headers: Headers;
};
export type getAdvanceInvoicesResponseError = (getAdvanceInvoicesResponse400 | getAdvanceInvoicesResponse401 | getAdvanceInvoicesResponse403 | getAdvanceInvoicesResponse404 | getAdvanceInvoicesResponse500) & {
  headers: Headers;
};

export type getAdvanceInvoicesResponse = (getAdvanceInvoicesResponseSuccess | getAdvanceInvoicesResponseError)

export const getGetAdvanceInvoicesUrl = (params?: GetAdvanceInvoicesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/advance-invoices?${stringifiedParams}` : `/advance-invoices`
}

export const getAdvanceInvoices = async (params?: GetAdvanceInvoicesParams, options?: RequestInit): Promise<getAdvanceInvoicesResponse> => {
  
  return customFetch<getAdvanceInvoicesResponse>(getGetAdvanceInvoicesUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Create an advance invoice with pre-calculated totals from an external system.
The caller provides `total`, `total_with_tax`, `total_discount`, and `taxes` at the document level, and `total`/`total_with_tax` on each line item.
When `calculation_mode` is omitted, Space Invoices preserves pass-through behavior and accepts the supplied totals as-is.
When `calculation_mode` is provided, Space Invoices validates the supplied totals against that calculation mode before creating the document.
All other logic (numbering, fiscalization, customer handling, payments, lifecycle hooks) is identical to the standard create endpoint.
 * @summary Create advance invoice with pre-calculated totals
 */
export type createCustomAdvanceInvoiceResponse201 = {
  data: AdvanceInvoice
  status: 201
}

export type createCustomAdvanceInvoiceResponse400 = {
  data: Error
  status: 400
}

export type createCustomAdvanceInvoiceResponse401 = {
  data: Error
  status: 401
}

export type createCustomAdvanceInvoiceResponse403 = {
  data: Error
  status: 403
}

export type createCustomAdvanceInvoiceResponse404 = {
  data: Error
  status: 404
}

export type createCustomAdvanceInvoiceResponse422 = {
  data: ValidationError
  status: 422
}

export type createCustomAdvanceInvoiceResponse500 = {
  data: Error
  status: 500
}

export type createCustomAdvanceInvoiceResponseSuccess = (createCustomAdvanceInvoiceResponse201) & {
  headers: Headers;
};
export type createCustomAdvanceInvoiceResponseError = (createCustomAdvanceInvoiceResponse400 | createCustomAdvanceInvoiceResponse401 | createCustomAdvanceInvoiceResponse403 | createCustomAdvanceInvoiceResponse404 | createCustomAdvanceInvoiceResponse422 | createCustomAdvanceInvoiceResponse500) & {
  headers: Headers;
};

export type createCustomAdvanceInvoiceResponse = (createCustomAdvanceInvoiceResponseSuccess | createCustomAdvanceInvoiceResponseError)

export const getCreateCustomAdvanceInvoiceUrl = () => {


  

  return `/advance-invoices/custom`
}

export const createCustomAdvanceInvoice = async (customCreateAdvanceInvoice: CustomCreateAdvanceInvoice, options?: RequestInit): Promise<createCustomAdvanceInvoiceResponse> => {
  
  return customFetch<createCustomAdvanceInvoiceResponse>(getCreateCustomAdvanceInvoiceUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      customCreateAdvanceInvoice,)
  }
);}
  

/**
 * Retrieve a single advance invoice by its unique identifier. Returns the complete advance invoice details including all line items, customer information, and calculated totals.
 * @summary Get advance invoice by ID
 */
export type getAdvanceInvoiceByIdResponse200 = {
  data: AdvanceInvoice
  status: 200
}

export type getAdvanceInvoiceByIdResponse401 = {
  data: Error
  status: 401
}

export type getAdvanceInvoiceByIdResponse403 = {
  data: Error
  status: 403
}

export type getAdvanceInvoiceByIdResponse404 = {
  data: Error
  status: 404
}

export type getAdvanceInvoiceByIdResponse500 = {
  data: Error
  status: 500
}

export type getAdvanceInvoiceByIdResponseSuccess = (getAdvanceInvoiceByIdResponse200) & {
  headers: Headers;
};
export type getAdvanceInvoiceByIdResponseError = (getAdvanceInvoiceByIdResponse401 | getAdvanceInvoiceByIdResponse403 | getAdvanceInvoiceByIdResponse404 | getAdvanceInvoiceByIdResponse500) & {
  headers: Headers;
};

export type getAdvanceInvoiceByIdResponse = (getAdvanceInvoiceByIdResponseSuccess | getAdvanceInvoiceByIdResponseError)

export const getGetAdvanceInvoiceByIdUrl = (id: string,
    params?: GetAdvanceInvoiceByIdParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/advance-invoices/${id}?${stringifiedParams}` : `/advance-invoices/${id}`
}

export const getAdvanceInvoiceById = async (id: string,
    params?: GetAdvanceInvoiceByIdParams, options?: RequestInit): Promise<getAdvanceInvoiceByIdResponse> => {
  
  return customFetch<getAdvanceInvoiceByIdResponse>(getGetAdvanceInvoiceByIdUrl(id,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Update an existing advance invoice.
Creates a version snapshot before applying changes.
Cannot update voided or FURS-fiscalized advance invoices.
If items are provided, they replace all existing items.
 * @summary Update an advance invoice
 */
export type updateAdvanceInvoiceResponse200 = {
  data: AdvanceInvoice
  status: 200
}

export type updateAdvanceInvoiceResponse400 = {
  data: Error
  status: 400
}

export type updateAdvanceInvoiceResponse401 = {
  data: Error
  status: 401
}

export type updateAdvanceInvoiceResponse403 = {
  data: Error
  status: 403
}

export type updateAdvanceInvoiceResponse404 = {
  data: Error
  status: 404
}

export type updateAdvanceInvoiceResponse422 = {
  data: ValidationError
  status: 422
}

export type updateAdvanceInvoiceResponse500 = {
  data: Error
  status: 500
}

export type updateAdvanceInvoiceResponseSuccess = (updateAdvanceInvoiceResponse200) & {
  headers: Headers;
};
export type updateAdvanceInvoiceResponseError = (updateAdvanceInvoiceResponse400 | updateAdvanceInvoiceResponse401 | updateAdvanceInvoiceResponse403 | updateAdvanceInvoiceResponse404 | updateAdvanceInvoiceResponse422 | updateAdvanceInvoiceResponse500) & {
  headers: Headers;
};

export type updateAdvanceInvoiceResponse = (updateAdvanceInvoiceResponseSuccess | updateAdvanceInvoiceResponseError)

export const getUpdateAdvanceInvoiceUrl = (id: string,) => {


  

  return `/advance-invoices/${id}`
}

export const updateAdvanceInvoice = async (id: string,
    updateAdvanceInvoice: UpdateAdvanceInvoice, options?: RequestInit): Promise<updateAdvanceInvoiceResponse> => {
  
  return customFetch<updateAdvanceInvoiceResponse>(getUpdateAdvanceInvoiceUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateAdvanceInvoice,)
  }
);}
  

/**
 * Retrieve the version history for an advance invoice. Each version represents the document state before an update was applied.
 * @summary Get advance invoice version history
 */
export type getAdvanceInvoiceVersionsResponse200 = {
  data: DocumentVersionList
  status: 200
}

export type getAdvanceInvoiceVersionsResponse401 = {
  data: Error
  status: 401
}

export type getAdvanceInvoiceVersionsResponse403 = {
  data: Error
  status: 403
}

export type getAdvanceInvoiceVersionsResponse404 = {
  data: Error
  status: 404
}

export type getAdvanceInvoiceVersionsResponse500 = {
  data: Error
  status: 500
}

export type getAdvanceInvoiceVersionsResponseSuccess = (getAdvanceInvoiceVersionsResponse200) & {
  headers: Headers;
};
export type getAdvanceInvoiceVersionsResponseError = (getAdvanceInvoiceVersionsResponse401 | getAdvanceInvoiceVersionsResponse403 | getAdvanceInvoiceVersionsResponse404 | getAdvanceInvoiceVersionsResponse500) & {
  headers: Headers;
};

export type getAdvanceInvoiceVersionsResponse = (getAdvanceInvoiceVersionsResponseSuccess | getAdvanceInvoiceVersionsResponseError)

export const getGetAdvanceInvoiceVersionsUrl = (id: string,) => {


  

  return `/advance-invoices/${id}/versions`
}

export const getAdvanceInvoiceVersions = async (id: string, options?: RequestInit): Promise<getAdvanceInvoiceVersionsResponse> => {
  
  return customFetch<getAdvanceInvoiceVersionsResponse>(getGetAdvanceInvoiceVersionsUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Retrieve a specific version snapshot of an advance invoice.
 * @summary Get specific advance invoice version
 */
export type getAdvanceInvoiceVersionResponse200 = {
  data: DocumentVersion
  status: 200
}

export type getAdvanceInvoiceVersionResponse401 = {
  data: Error
  status: 401
}

export type getAdvanceInvoiceVersionResponse403 = {
  data: Error
  status: 403
}

export type getAdvanceInvoiceVersionResponse404 = {
  data: Error
  status: 404
}

export type getAdvanceInvoiceVersionResponse500 = {
  data: Error
  status: 500
}

export type getAdvanceInvoiceVersionResponseSuccess = (getAdvanceInvoiceVersionResponse200) & {
  headers: Headers;
};
export type getAdvanceInvoiceVersionResponseError = (getAdvanceInvoiceVersionResponse401 | getAdvanceInvoiceVersionResponse403 | getAdvanceInvoiceVersionResponse404 | getAdvanceInvoiceVersionResponse500) & {
  headers: Headers;
};

export type getAdvanceInvoiceVersionResponse = (getAdvanceInvoiceVersionResponseSuccess | getAdvanceInvoiceVersionResponseError)

export const getGetAdvanceInvoiceVersionUrl = (id: string,
    version: number,) => {


  

  return `/advance-invoices/${id}/versions/${version}`
}

export const getAdvanceInvoiceVersion = async (id: string,
    version: number, options?: RequestInit): Promise<getAdvanceInvoiceVersionResponse> => {
  
  return customFetch<getAdvanceInvoiceVersionResponse>(getGetAdvanceInvoiceVersionUrl(id,version),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Render an HTML preview of an advance invoice without saving to the database. Perfect for displaying live previews in advance invoice creation/edit forms. Supports both partial mode (allows incomplete data for drafts) and complete mode (validates all required fields).
 * @summary Render advance invoice preview
 */
export type renderAdvanceInvoicePreviewResponse200 = {
  data: string
  status: 200
}

export type renderAdvanceInvoicePreviewResponse400 = {
  data: Error
  status: 400
}

export type renderAdvanceInvoicePreviewResponse401 = {
  data: Error
  status: 401
}

export type renderAdvanceInvoicePreviewResponse403 = {
  data: Error
  status: 403
}

export type renderAdvanceInvoicePreviewResponse404 = {
  data: Error
  status: 404
}

export type renderAdvanceInvoicePreviewResponse422 = {
  data: ValidationError
  status: 422
}

export type renderAdvanceInvoicePreviewResponse500 = {
  data: Error
  status: 500
}

export type renderAdvanceInvoicePreviewResponseSuccess = (renderAdvanceInvoicePreviewResponse200) & {
  headers: Headers;
};
export type renderAdvanceInvoicePreviewResponseError = (renderAdvanceInvoicePreviewResponse400 | renderAdvanceInvoicePreviewResponse401 | renderAdvanceInvoicePreviewResponse403 | renderAdvanceInvoicePreviewResponse404 | renderAdvanceInvoicePreviewResponse422 | renderAdvanceInvoicePreviewResponse500) & {
  headers: Headers;
};

export type renderAdvanceInvoicePreviewResponse = (renderAdvanceInvoicePreviewResponseSuccess | renderAdvanceInvoicePreviewResponseError)

export const getRenderAdvanceInvoicePreviewUrl = (params?: RenderAdvanceInvoicePreviewParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/advance-invoices/render?${stringifiedParams}` : `/advance-invoices/render`
}

export const renderAdvanceInvoicePreview = async (partialAdvanceInvoicePreviewCompleteAdvanceInvoicePreview: PartialAdvanceInvoicePreview | CompleteAdvanceInvoicePreview,
    params?: RenderAdvanceInvoicePreviewParams, options?: RequestInit): Promise<renderAdvanceInvoicePreviewResponse> => {
  
  return customFetch<renderAdvanceInvoicePreviewResponse>(getRenderAdvanceInvoicePreviewUrl(params),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      partialAdvanceInvoicePreviewCompleteAdvanceInvoicePreview,)
  }
);}
  

/**
 * Void an advance invoice for technical reasons (duplicate, error, etc.). For FURS-fiscalized advance invoices, automatically submits technical cancellation to FURS. All linked payments are soft-deleted, reversing their effect on invoice totals.
 * @summary Void an advance invoice
 */
export type voidAdvanceInvoiceResponse200 = {
  data: AdvanceInvoice
  status: 200
}

export type voidAdvanceInvoiceResponse400 = {
  data: Error
  status: 400
}

export type voidAdvanceInvoiceResponse401 = {
  data: Error
  status: 401
}

export type voidAdvanceInvoiceResponse403 = {
  data: Error
  status: 403
}

export type voidAdvanceInvoiceResponse404 = {
  data: Error
  status: 404
}

export type voidAdvanceInvoiceResponse422 = {
  data: ValidationError
  status: 422
}

export type voidAdvanceInvoiceResponse500 = {
  data: Error
  status: 500
}

export type voidAdvanceInvoiceResponseSuccess = (voidAdvanceInvoiceResponse200) & {
  headers: Headers;
};
export type voidAdvanceInvoiceResponseError = (voidAdvanceInvoiceResponse400 | voidAdvanceInvoiceResponse401 | voidAdvanceInvoiceResponse403 | voidAdvanceInvoiceResponse404 | voidAdvanceInvoiceResponse422 | voidAdvanceInvoiceResponse500) & {
  headers: Headers;
};

export type voidAdvanceInvoiceResponse = (voidAdvanceInvoiceResponseSuccess | voidAdvanceInvoiceResponseError)

export const getVoidAdvanceInvoiceUrl = (id: string,) => {


  

  return `/advance-invoices/${id}/void`
}

export const voidAdvanceInvoice = async (id: string,
    voidAdvanceInvoiceBody: VoidAdvanceInvoiceBody, options?: RequestInit): Promise<voidAdvanceInvoiceResponse> => {
  
  return customFetch<voidAdvanceInvoiceResponse>(getVoidAdvanceInvoiceUrl(id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      voidAdvanceInvoiceBody,)
  }
);}
  

